Number.prototype.between = function (firstNum, secondNum) {
  const min = Math.min(firstNum, secondNum)
  const max = Math.max(firstNum, secondNum)

  return this >= min && this <= max
}
